export default __webpack_public_path__ + "static/media/2165.8dab189d.png";